import railsAxios from './railsAxios';
import captureRenderBlockingException from '../tracking/helpers/captureRenderBlockingException';

function emitUniversalMetricsEvent(eventType) {
  railsAxios.post('/api/emit-universal-metrics-event', { event_type: eventType })
    .catch((e) => {
      captureRenderBlockingException(e);
    });
}

export default emitUniversalMetricsEvent;
